// src/components/Navbar.jsx
// ✅ Última actualización: 2026-03-23 - Sistema Visual Integrado
// Cambios aplicados:
// - Eliminada fragmentación cromática (todo sobre bg azul oscuro)
// - Altura reducida manteniendo coherencia visual
// - Tagline integrado con mejor tipografía
// - Navegación unificada en mismo sistema visual
// - Spacing inteligente: menos padding vertical, mejor separación entre elementos

import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="sticky top-0 w-full z-50 bg-[#081827] text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 md:py-4">
        {/* Bloque de identidad */}
        <div className="flex flex-col items-center justify-center space-y-1 md:space-y-3">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-90 transition-opacity">
            <img
              src="/assets/logocompleto.png"
              alt="Edutech Pulse Lab Logo"
              className="h-8 md:h-11"
            />
          </Link>
          
          {/* Tagline - Integrado con mejor tipografía */}
          <span className="text-xs md:text-sm text-gray-400 text-center tracking-wide font-light">
            Aprende con propósito y aplica con impacto
          </span>
        </div>
        
        {/* Navegación - Unificada en el mismo sistema visual */}
        <div className="flex items-center justify-center mt-2 md:mt-4 pt-2 md:pt-4 border-t border-white/10">
          <div className="flex justify-center space-x-4 sm:space-x-6 md:space-x-8 text-sm md:text-sm">
            <Link 
              to="/" 
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium tracking-wide"
            >
              INICIO
            </Link>
            <Link 
              to="/recursos" 
              className="text-gray-300 hover:text-white transition-colors duration-200 tracking-wide"
            >
              RECURSOS
            </Link>
            <Link 
              to="/colecciones" 
              className="text-gray-300 hover:text-white transition-colors duration-200 tracking-wide font-medium"
            >
              COLECCIONES
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}